const OrderList = ({ children }) => {
	return <ol>{children}</ol>;
};

export default OrderList;
